const mapPageName = "Map";
const recordDetailPageName = "Record Detail";
const latestPhotoPageName = "Latest Photo Record";
const summaryPageName = "Summary";
const accountPageName = "Account";

export {
    mapPageName,
    recordDetailPageName,
    latestPhotoPageName,
    summaryPageName,
    accountPageName,
};
